const rosetta: Array<RosettaStone> = [
	{
		key: 'families',
		ace: 'Families',
	},
	{
		key: 'teens',
		ace: 'Teens',
	},
	{
		key: 'adults',
		ace: 'Adults',
	},
	{
		key: 'access',
		ace: 'Access',
	},
	{
		key: 'educators',
		ace: 'Educators',
	},

	{
		key: 'highlights',
		ace: 'Highlights',
	},

	// Languages
	{
		key: 'zh',
		ace: 'Languages|Chinese',
	},
	{
		key: 'fr',
		ace: 'Languages|French',
	},
	{
		key: 'de',
		ace: 'Languages|German',
	},
	{
		key: 'it',
		ace: 'Languages|Italian',
	},
	{
		key: 'ja',
		ace: 'Languages|Japanese',
	},
	{
		key: 'ko',
		ace: 'Languages|Korean',
	},
	{
		key: 'pt',
		ace: 'Languages|Portuguese',
	},
	{
		key: 'ru',
		ace: 'Languages|Russian',
	},
	{
		key: 'es',
		ace: 'Languages|Spanish',
	},
	{
		key: 'ar',
		ace: 'Languages|Arabic',
	},

	// Member types

	{
		key: 'members',
		ace: 'Members',
	},
	{
		key: 'individual',
		ace: 'Members|Individual',
	},
	{
		key: 'dual',
		ace: 'Members|Dual',
	},
	{
		key: 'family',
		ace: 'Members|Family',
	},
	{
		key: 'enthusiast',
		ace: 'Members|Enthusiast',
	},
	{
		key: 'ambassador',
		ace: 'Members|Ambassador',
	},
	{
		key: 'global',
		ace: 'Members|Global',
	},
	{
		key: 'patrons',
		ace: 'Patrons',
	},
	{
		key: 'insider',
		ace: 'Patrons|Insider',
	},
	{
		key: 'champion',
		ace: 'Patrons|Champion',
	},

	// Event types

	{
		key: 'talks',
		ace: 'Talks',
	},
	{
		key: 'workshopsClasses',
		ace: 'Workshops and Classes',
	},
	{
		key: 'workshops',
		ace: 'Workshops',
	},
	{
		key: 'classes',
		ace: 'Classes',
	},
	{
		key: 'celebrations',
		ace: 'Celebrations',
	},
	{
		key: 'festivals',
		ace: 'Celebrations|Festivals',
	},
	{
		key: 'benefits',
		ace: 'Celebrations|Benefits & Galas',
	},
	{
		key: 'performances',
		ace: 'Performances',
	},
	{
		key: 'performanceArt',
		ace: 'Performances|Performance Art',
	},
	{
		key: 'music',
		ace: 'Performances|Music',
	},
	{
		key: 'dance',
		ace: 'Performances|Dance',
	},
	{
		key: 'film',
		ace: 'Film',
	},

	{
		key: 'theMetFifthAvenue',
		ace: 'The Met Fifth Avenue',
	},
	{
		key: 'theMetCloisters',
		ace: 'The Met Cloisters',
	},
	{
		key: 'online',
		ace: 'Online',
	},
	{
		key: 'offsite',
		ace: 'Offsite',
	},

	// Price buckets (not actually ACE)
	{
		key: 'free',
		ace: 'free',
	},
	{
		key: 'paid',
		ace: 'paid',
	},

	// Collection areas. The keys need to match the department slug
	{
		key: 'collectionAreas',
		ace: 'Collection Areas',
	},
	{
		key: 'sub-saharan-africa-art',
		ace: 'Collection Areas|African Art in The Michael C. Rockefeller Wing',
	},
	{
		key: 'ancient-american-art',
		ace: 'Collection Areas|Ancient American Art in The Michael C. Rockefeller Wing',
	},
	{
		key: 'ancient-west-asian-art',
		ace: 'Collection Areas|Ancient West Asian Art',
	},
	{
		key: 'the-american-wing',
		ace: 'Collection Areas|The American Wing',
	},
	{
		key: 'arms-and-armor',
		ace: 'Collection Areas|Arms and Armor',
	},
	{
		key: 'arts-of-africa-oceania-and-the-americas',
		ace: 'Collection Areas|Arts of Africa, Oceania, and the Americas',
	},
	{
		key: 'asian-art',
		ace: 'Collection Areas|Asian Art',
	},
	{
		key: 'drawings-and-prints',
		ace: 'Collection Areas|Drawings and Prints',
	},
	{
		key: 'egyptian-art',
		ace: 'Collection Areas|Egyptian Art',
	},
	{
		key: 'european-paintings-1250-1800',
		ace: 'Collection Areas|European Paintings',
	},
	{
		key: 'european-sculpture-and-decorative-arts',
		ace: 'Collection Areas|European Sculpture and Decorative Arts',
	},
	{
		key: 'greek-and-roman-art',
		ace: 'Collection Areas|Greek and Roman Art',
	},
	{
		key: 'islamic-art',
		ace: 'Collection Areas|Islamic Art',
	},
	{
		key: 'the-robert-lehman-collection',
		ace: 'Collection Areas|The Robert Lehman Collection',
	},
	{
		key: 'medieval-art-and-the-cloisters',
		ace: 'Collection Areas|Medieval Art and The Cloisters',
	},
	{
		key: 'modern-and-contemporary-art',
		ace: 'Collection Areas|Modern and Contemporary',
	},
	{
		key: 'musical-instruments',
		ace: 'Collection Areas|Musical Instruments',
	},
	{
		key: 'oceanic-art',
		ace: 'Collection Areas|Oceanic Art in The Michael C. Rockefeller Wing',
	},
	{
		key: 'photographs',
		ace: 'Collection Areas|Photographs',
	},
	{
		key: 'the-costume-institute',
		ace: 'Collection Areas|The Costume Institute',
	},
	{
		key: 'the-michael-c-rockefeller-wing',
		ace: 'Collection Areas|The Michael C. Rockefeller Wing',
	},

	// Access types

	{
		key: 'blindOrPartiallySighted',
		ace: 'Access|Visitors who are Blind or Partially Sighted',
	},
	{
		key: 'hearingLoss',
		ace: 'Access|Visitors with Hearing Loss',
	},
	{
		key: 'dementia',
		ace: 'Access|Visitors with Dementia and Their Care Partners',
	},
	{
		key: 'learningDisabilities',
		ace: 'Access|Visitors with Developmental and Learning Disabilities and Those on the Autism Spectrum',
	},

	// Identity and heritage
	{
		key: 'heritageIdentity',
		ace: 'Heritage and Identity',
	},
	{
		key: 'blackHistoryMonth',
		ace: 'Heritage and Identity|Black History Month (February)',
	},
	{
		key: 'womensHistoryMonth',
		ace: "Heritage and Identity|Women's History Month (March)",
	},
	{
		key: 'asianPacificHeritage',
		ace: 'Heritage and Identity|Asian American and Pacific Islander Heritage Month (May)',
	},
	{
		key: 'lgbtqiaPrideMonth',
		ace: 'Heritage and Identity|LGBTQIA+ Pride Month (June)',
	},
	{
		key: 'disabilityPrideMonth',
		ace: 'Heritage and Identity|Disability Pride Month (July)',
	},
	{
		key: 'hispanicLatine',
		ace: 'Heritage and Identity|Hispanic/Latine Heritage Month (September 15 – October 15)',
	},
	{
		key: 'hispanicLatineTour',
		ace: 'Heritage & Identity|Hispanic/Latine Heritage Month (September 15 – October 15)',
	},
	{
		key: 'nativeIndigenousHeritage',
		ace: 'Heritage and Identity|Native American and Indigenous Heritage Month (November)',
	},
];

export const aceUrlKeys: { [key: string]: string } = rosetta.reduce(
	(obj, value) => {
		// filter out keys with dashes, those are departments, and handled elsewhere
		if (!value.key.includes('-') && value.key !== 'photographs') {
			obj[value.key] = value.key;
		}
		return obj;
	},
	{},
);

export const getAceSearchString = (filterKey: string): string => {
	const translation = rosetta.find((item) => item.key == filterKey);
	return translation ? translation.ace : '';
};

export const getAceFilterKey = (aceSearchString: string): string => {
	const translation = rosetta.find((item) => item.ace == aceSearchString);
	return translation ? translation.key : '';
};

export type RosettaStone = {
	key: string;
	ace: string;
};
